module.exports = __webpack_public_path__ + "img/Logo-28.a3171693.svg";